import { Component, OnInit , ViewChild, ElementRef} from '@angular/core';
import { FormGroup, Validators, FormBuilder,FormControl } from '@angular/forms';
import {ActivatedRoute , Router } from '@angular/router';
import {AuthService}from '../../../../auth-guard/auth.service';
import { TemplateRef } from '@angular/core';

import { MtxDialog } from '@ng-matero/extensions/dialog';

@Component({
  selector: 'app-fccp-verification',
  templateUrl: './fccp-verification.html',
//   styleUrls:['./fccp-layout.scss']
})

export class FccpVerification implements OnInit {
    verifyform: FormGroup;
    paramdata:any;
    userdtl:any;
    urldata:any;
    constructor(private fb: FormBuilder,private route:ActivatedRoute, private router: Router,private authservice:AuthService,public dialog: MtxDialog) {
        this.intform();
        this.userdtl=this.authservice.getstoragedtl();
        // if(Object.keys(this.route.snapshot.queryParams).length > 0)
        // {
        //   console.log(this.route.snapshot.queryParams);
        // } 

    }
    ngOnInit(){
        //   this.route.paramMap.subscribe(params => {
        //     this.verifyemail = params.get("emailid");
        //     console.log(this.verifyemail);
        // })
        if(Object.keys(this.route.snapshot.queryParams).length > 0)
        {
        this.urldata=this.route.snapshot.queryParams
         //   console.log( this.urldata.emailid);
          this.verifyform.get('email').setValue(this.urldata.emailid);
        }
    }

    intform(){
        this.verifyform = this.fb.group({
            email : ['', [Validators.required,Validators.email]],
            verify_cd: ['', [Validators.required]],
          });
    }

    userverification()
    {
        this.paramdata={};
        this.paramdata.user_email=this.verifyform.get('email').value,
        this.paramdata.ver_code=this.verifyform.get('verify_cd').value,
        this.paramdata.poolcode = 'FCCP'; 
        this.authservice.IUDdata('verification',this.paramdata,'json').subscribe((data:any) => 
        { 

            if(data.length > 0)
            {
                if(data[0].result_cd == 'S')
                {
                    this.authservice.showSuccess('top-center',' Your user id has been activated and is ready to use. Please login to book chassis',10000) ; 
                    this.router.navigate(['/fccp/fccplogin']);
                    // this.intform() ;
                }
                else{
                    if(this.urldata.emailid!=this.verifyform.get('email').value)
                    {
                        this.authservice.showToasterror('top-center','Sorry..! You Entered Wrong Email Id',10000)  ;
                    }
                    else
                    {
                        this.authservice.showToasterror('top-center','Verification Code is Wrong',10000) 
                    }
                }
                
            }
            else
            {
                   if(this.urldata.emailid!=this.verifyform.get('email').value)
                   {
                    this.authservice.showToasterror('top-center','Sorry..! You Entered Wrong Email Id',10000)  ;
                   }
                   else
                   {
                    this.authservice.showToasterror('top-center','Verification Code is Wrong',10000) 
                   }

            }

        },
        onerror => 
        {
            this.authservice.showToasterror('top-full-width','Technical Error..',2000) ;    
            
        });
    }

    gotologin()
    {
      this.router.navigate(['/fccp/fccplogin']);
    }
}